export const QuestionType = {
    LikertScale5: 'likert_scale_5',
    MostLeast: 'max_diff',
    RankOrder: 'rank_order',
    SingleSelectMultipleChoice: 'single_select_multiple_choice',
}